import { EventEmitter } from 'events';
import { Component, Input, Output } from '@angular/core';
import { FormControlComponent } from '@forms/form-control/form-control.component';

export interface SelectOption {
  name: string;
  value: string;
}

@Component({
  selector: 'rav-select',
  templateUrl: './select.component.html'
})
export class SelectComponent extends FormControlComponent {
  @Input() selectOptions: Array<SelectOption>;
  @Output() selectChange: EventEmitter;

  constructor() {
    super();
  }
}
